import { Heading, Subheading } from '../components/heading'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/table'
import { CircleStackIcon } from '@heroicons/react/16/solid';
import { Divider } from '../components/divider'
import { Badge } from '../components/badge'
import { Loader } from '../components/loader'
import config from '../config.js'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSession } from '../components/session-provider'

export function DashboardContent() {
    const [accList, setAccList] = useState([]);
    const [totalAccounts, setTotalAccounts] = useState(0);
    const [totalTests, setTotalTests] = useState(0);
    const [recentAccounts, setRecentAccounts] = useState(0);
    const [avgUplift, setAvgUplift] = useState(0);
    const [totalTokens, setTotalTokens] = useState(0);
    const { session, setSession } = useSession();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const getDashboardInfo = async() => {
      setLoading(true);
      const response = await fetch(`${config.apiPath}dashboard/dashboard-ajax.php?type=get_dashboard_info`,{ method: 'GET',credentials: 'include' });
      const list_res = await response.json();
      if(list_res.status === 'error') {
        window.location.href = `/${config.appPath}`;
      }
      else {
        setAccList(list_res.overview_data);
        setTotalAccounts(list_res.total_companies);
        setTotalTests(list_res.total_test);
        setAvgUplift(list_res.avg_uplift);
        setTotalTokens(list_res.total_tokens);
        setRecentAccounts(list_res.recent_accounts);
      }
      setLoading(false);
    }
    useEffect(() => {
        getDashboardInfo();
    }, []);
    const SwapCompany = async(sumo_account_id) => {
      try {
        setLoading(true);
        const response = await fetch(`${config.apiPath}swap-company.php?sumo_account_id=${sumo_account_id}`, { credentials: 'include' });
        const swap_res = await response.json();
        if(swap_res.status === "success") {
          setSession(swap_res.data); 
          navigate("/title-test?reload=" + Date.now());
          setLoading(false);
        }  else {
          Logout();
        }
      }
      catch (error) {
        console.error("Session check failed:", error);
        setLoading(false);
        Logout();
      }
    }
    const Logout = async() => {
      try {
        setLoading(true);
        await fetch(`${config.apiPath}logout.php`);
        setLoading(false);
        navigate('/');
      }
      catch (error) {
        console.error("Logout failed:", error);
        setLoading(false);
        navigate('/');
      }
    }
    return (
    <>
      <div className="flex w-full items-center gap-3 rounded-lg px-2 py-2.5 text-left text-base/4 font-medium text-zinc-950 sm:py-2 sm:text-sm/4 *:data-[slot=icon]:size-6 *:data-[slot=icon]:shrink-0 *:data-[slot=icon]:fill-zinc-500 sm:*:data-[slot=icon]:size-5 *:last:data-[slot=icon]:ml-auto *:last:data-[slot=icon]:size-5 sm:*:last:data-[slot=icon]:size-4 *:data-[slot=avatar]:-m-0.5 *:data-[slot=avatar]:size-7 sm:*:data-[slot=avatar]:size-6 data-hover:bg-zinc-950/5 data-hover:*:data-[slot=icon]:fill-zinc-950 data-active:bg-zinc-950/5 data-active:*:data-[slot=icon]:fill-zinc-950 data-current:*:data-[slot=icon]:fill-zinc-950 dark:text-white dark:*:data-[slot=icon]:fill-zinc-400 dark:data-hover:bg-white/5 dark:data-hover:*:data-[slot=icon]:fill-white dark:data-active:bg-white/5 dark:data-active:*:data-[slot=icon]:fill-white dark:data-current:*:data-[slot=icon]:fill-white">
      <CircleStackIcon className="!size-8" />
      <Heading>Your Dashboard</Heading>
      </div>
      <div className="mt-8 flex items-end justify-between">
        <Subheading>Overview</Subheading>
      </div>
      <div className="mt-4 grid gap-8 sm:grid-cols-2 xl:grid-cols-4">
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Total Accounts</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">{totalAccounts}</div>
              <div className="mt-3 text-sm/6 sm:text-xs/6">
                <Badge color='lime'>+{recentAccounts}</Badge>{' '}
                <span className="text-zinc-500">from last week</span>
              </div>
        </div>
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Total Tests</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">{totalTests}</div>
        </div>
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Average Uplift Found</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">{avgUplift}%</div>
        </div>
        <div className='rounded-lg'>
              <Divider />
              <div className="mt-4 text-lg/6 font-medium sm:text-sm/6 dark:text-white">Tokens used (this month)</div>
              <div className="mt-3 text-3xl/8 font-semibold sm:text-2xl/8 dark:text-white">{totalTokens}</div>
        </div>
      </div>
      <Table grid className="mt-12 h-[450px] [--gutter:--spacing(6)] lg:[--gutter:--spacing(10)]">
        <TableHead className="sticky top-0 z-30 bg-white dark:bg-zinc-900">
          <TableRow>
            <TableHeader>Account Name</TableHeader>
            <TableHeader>Country</TableHeader>
            <TableHeader>Title tests</TableHeader>
            <TableHeader>Average uplift</TableHeader>
            <TableHeader>Tokens used</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody className="sticky top-0 z-20">
           {
        !Object.keys(accList).length ? 
          (<></>) :
          (
            accList.map((res, index) => (
              <TableRow>
                <TableCell>
                  <a className="text-indigo-600 hover:text-indigo-900 dark:text-indigo-400 dark:hover:text-indigo-300 cursor-pointer" onClick={() => SwapCompany(res.sumo_account_id)}>{res.account_name}</a>
                </TableCell>
                <TableCell>{res.country}</TableCell>
                <TableCell>{res.total_test}</TableCell>
                <TableCell>
                {
                    res.avg_uplift === "" ? <Badge color="yellow">Not Applicable</Badge> : (res.avg_uplift >= 0 ? <Badge color="green">{res.avg_uplift}%</Badge> : <Badge color="red">{res.avg_uplift}%</Badge>) 
                }  
                </TableCell>
                <TableCell>{res.total_tokens}</TableCell>
              </TableRow>
            ))
          )
          }
        </TableBody>
      </Table>
      {loading && (
        <Loader />
      )}
    </>
    );
}